import { render, staticRenderFns } from "./LaboratoryPartnerService.vue?vue&type=template&id=4d1e194e&scoped=true"
import script from "./LaboratoryPartnerService.vue?vue&type=script&lang=js"
export * from "./LaboratoryPartnerService.vue?vue&type=script&lang=js"
import style0 from "./LaboratoryPartnerService.vue?vue&type=style&index=0&id=4d1e194e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e194e",
  null
  
)

export default component.exports